export default "__VITE_ASSET__DJ3H7T$c__"